module.exports = __webpack_public_path__ + "img/faq-img-04.5d7bd63.jpg";